import React from 'react';
import { FadeInUp, ScaleIn } from './Animations';

const ventures = [
  {
    href: 'https://ideraherbals.com.ng',
    gradient: 'linear-gradient(135deg, #1E8449 0%, #27AE60 100%)',
    shadowColor: 'rgba(30,132,73,0.25)',
    icon: '🌿',
    tag: 'Health & Wellness',
    title: 'Idera Herbal Care',
    desc: 'Discover the power of nature through Idera Health Care — premium herbal and wellness products that heal, nourish, and restore your body from the inside out.',
    features: ['Natural Herbal Products', 'Wellness Coaching', 'Join & Earn Income'],
    cta: 'Explore Products',
    live: true,
  },
  {
    href: 'https://wa.me/2347069495976?text=Hi%20Gracious%2C%20I%20am%20interested%20in%20your%20Real%20Estate%20opportunities.%20Please%20tell%20me%20more.',
    gradient: 'linear-gradient(135deg, #C9973A 0%, #E8B84B 100%)',
    shadowColor: 'rgba(201,151,58,0.25)',
    icon: '🏠',
    tag: 'Investment & Wealth',
    title: 'Real Estate',
    desc: 'Smart property investment opportunities across Nigeria. Buy land, invest in properties, and build long-term wealth the smart way.',
    features: ['Land & Property Sales', 'Investment Advisory', 'Wealth Building'],
    cta: 'Enquire Now',
    live: true,
  },
  {
    href: 'https://wa.me/2347069495976?text=Hi%20Gracious%2C%20I%20am%20interested%20in%20your%20Digital%20Marketing%20services.%20Please%20tell%20me%20more.',
    gradient: 'linear-gradient(135deg, #2471A3 0%, #3498DB 100%)',
    shadowColor: 'rgba(36,113,163,0.25)',
    icon: '📱',
    tag: 'Online Business',
    title: 'Digital Marketing',
    desc: 'Build a powerful online presence that attracts customers and generates income on autopilot. From social media to sales funnels.',
    features: ['Social Media Strategy', 'Sales Funnel Building', 'Brand Development'],
    cta: 'Enquire Now',
    live: true,
  },
  {
    href: 'https://wa.me/2347069495976',
    gradient: 'linear-gradient(135deg, #6C3483 0%, #8E44AD 100%)',
    shadowColor: 'rgba(108,52,131,0.25)',
    icon: '🤝',
    tag: 'Coaching & Mentorship',
    title: 'MLM & Network Coaching',
    desc: 'Learn how to build, lead, and grow a successful network marketing team with consistent income across multiple companies.',
    features: ['Team Building Strategy', 'Leadership Coaching', 'Income Duplication'],
    cta: 'Book a Session',
    live: true,
  },
];

export default function Ventures() {
  return (
    <section id="ventures" style={{
      background: 'linear-gradient(160deg, #3D2008 0%, #7A4510 40%, #C9973A 100%)',
      padding: 'clamp(60px, 8vw, 100px) clamp(20px, 4vw, 52px)',
    }}>
      <FadeInUp>
        <div style={{ textAlign: 'center', maxWidth: '640px', margin: '0 auto 64px' }}>
          <span style={{
            fontFamily: "'Inter', sans-serif",
            fontSize: '14px', fontWeight: 800, letterSpacing: '3px',
            textTransform: 'uppercase', color: '#fff',
            marginBottom: '12px', display: 'block',
          }}>What I Do</span>
          <div style={{
            width: '48px', height: '3px',
            background: 'rgba(255,255,255,0.5)',
            margin: '0 auto 20px', borderRadius: '999px',
          }} />
          <h2 style={{
            fontFamily: "'Playfair Display', serif",
            fontSize: 'clamp(28px, 4vw, 46px)', fontWeight: 700,
            lineHeight: 1.15, marginBottom: '16px', color: '#fff',
          }}>
            My <em style={{ fontStyle: 'italic', color: '#FFD700' }}>Ventures</em>
          </h2>
          <p style={{ fontSize: '15px', lineHeight: 1.75, color: 'rgba(255,255,255,0.85)' }}>
            I work across multiple industries to create real impact and real income. Each venture is an opportunity for you to grow alongside me.
          </p>
        </div>
      </FadeInUp>

      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
        gap: '24px', maxWidth: '1160px', margin: '0 auto',
      }}>
        {ventures.map((v, i) => (
          <ScaleIn key={v.title} delay={i * 0.1}>
            <a href={v.href}
              target='_blank'
              rel="noreferrer"
              style={{
                background: '#fff',
                borderRadius: '20px',
                overflow: 'hidden',
                textDecoration: 'none',
                color: '#1A1A1A',
                border: '1px solid #F0F0F0',
                display: 'flex',
                flexDirection: 'column',
                boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                height: '100%',
              }}
              onMouseEnter={e => {
                e.currentTarget.style.transform = 'translateY(-8px)';
                e.currentTarget.style.boxShadow = `0 20px 40px ${v.shadowColor}`;
              }}
              onMouseLeave={e => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.06)';
              }}
            >
              {/* Gradient image area */}
              <div style={{
                height: '140px',
                background: v.gradient,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                position: 'relative', overflow: 'hidden',
              }}>
                <div style={{
                  position: 'absolute', top: '-20px', right: '-20px',
                  width: '100px', height: '100px', borderRadius: '50%',
                  background: 'rgba(255,255,255,0.12)',
                }} />
                <div style={{
                  position: 'absolute', bottom: '-30px', left: '-10px',
                  width: '90px', height: '90px', borderRadius: '50%',
                  background: 'rgba(255,255,255,0.08)',
                }} />
                <span style={{ fontSize: '44px', position: 'relative', zIndex: 1 }}>{v.icon}</span>
              </div>

              {/* Body */}
              <div style={{ padding: '24px 22px', flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                <span style={{
                  fontFamily: "'Inter', sans-serif",
                  fontSize: '10px', fontWeight: 700, letterSpacing: '2px',
                  textTransform: 'uppercase', color: '#9CA3AF',
                  marginBottom: '6px', display: 'block',
                }}>{v.tag}</span>
                <h3 style={{
                  fontFamily: "'Playfair Display', serif",
                  fontSize: '19px', fontWeight: 700,
                  marginBottom: '10px', color: '#111827',
                  lineHeight: 1.3,
                }}>{v.title}</h3>
                <p style={{
                  fontSize: '13.5px', lineHeight: 1.7,
                  color: '#6B7280', marginBottom: '16px', flexGrow: 1,
                }}>{v.desc}</p>

                <ul style={{ listStyle: 'none', marginBottom: '20px', display: 'flex', flexDirection: 'column', gap: '5px' }}>
                  {v.features.map(f => (
                    <li key={f} style={{
                      fontSize: '12.5px', color: '#4B5563',
                      display: 'flex', alignItems: 'center', gap: '7px',
                    }}>
                      <span style={{
                        width: '16px', height: '16px', borderRadius: '50%',
                        background: '#F0FDF4', display: 'flex',
                        alignItems: 'center', justifyContent: 'center',
                        fontSize: '9px', color: '#1E8449', fontWeight: 700,
                        flexShrink: 0,
                      }}>✓</span>
                      {f}
                    </li>
                  ))}
                </ul>

                <div style={{
                  fontFamily: "'Inter', sans-serif",
                  fontSize: '11px', fontWeight: 700, letterSpacing: '2px',
                  textTransform: 'uppercase',
                  color: v.live ? '#1E8449' : '#9CA3AF',
                  display: 'flex', alignItems: 'center', gap: '8px',
                  borderTop: '1px solid #F3F4F6', paddingTop: '14px',
                  transition: 'gap 0.3s',
                }}>
                  {v.cta} <span>{v.live ? '→' : '⏳'}</span>
                </div>
              </div>
            </a>
          </ScaleIn>
        ))}
      </div>
    </section>
  );
}
